import { ComponentStyleConfig } from '@chakra-ui/react';

export const Badge: ComponentStyleConfig = {
    baseStyle: {
        borderRadius: 0
    }
};
